import './CategorizationStatisticsDashboard.scss'
import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {useStores} from "../../../../stores";
import Typography from "@mui/material/Typography";
import {Grid} from "@mui/material";
import {DistributionComponent} from "../../../../components/categorization-review/DistributionComponent";
import {TotalReviewedAiResult} from "../../../../components/categorization-review/TotalReviewedAiResult";
import {CoveredByAi} from "../../../../components/categorization-review/CoveredByAi";
import {CategorizedTransactions} from "../../../../components/categorization-review/CategorizedTransactions";
import {CategoriesCoveredByAi} from "../../../../components/categorization-review/CategoriesCoveredByAi";
import {toCurrency} from "../../../../components/currency-component/CurrencyClasses";
import {useNavigate} from "react-router";
import {HelpComponent} from "../../../../components/help-component/HelpComponent";

export const CategorizationStatisticsDashboard: React.FC = observer(() => {
    const {p, categorizationReviewStore} = useStores();
    const statisticsDashboardController = categorizationReviewStore.statisticsDashboardController;
    const filterController = categorizationReviewStore.reviewPageController.reviewPageFilterController;
    const navigate = useNavigate();

    useEffect(() => {
        statisticsDashboardController.getCategorizationVersionedStatistics(categorizationReviewStore.bagId)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="categorization-statistics-dashboard" style={{cursor: 'default'}}>

            {/*1st part of the page*/}
            <Grid container sx={{mb: 5}}>
                <Grid container size={6} justifyContent="center">
                    <Grid container size={12}>
                        <Grid size={12}>
                            <Typography className="font-weight-bold key-value" sx={{mb: 2}}>
                                Average Ai score
                            </Typography>
                        </Grid>
                        <Grid size={12}>
                            <Typography variant="h4" className="key-values" sx={{mb: 2}}>
                                {statisticsDashboardController.stats
                                    ? (statisticsDashboardController.stats.average_confidence_score * 100).toFixed(2)
                                    : 0
                                } %
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container size={12}>
                        <Typography className="font-weight-bold key-value">
                            Total of review Ai results (transactions)
                        </Typography>
                        <TotalReviewedAiResult
                            data={statisticsDashboardController.totalReviewedAiResultBarDataPoint}
                        />
                    </Grid>
                </Grid>
                <Grid size={6} sx={{mb: 5}}>
                    <Typography className="font-weight-bold key-value">
                        Distribution of Ai results
                    </Typography>
                    <DistributionComponent
                        data={statisticsDashboardController.distributionBarDataPoint}
                        handleBarClick={(d) => {
                            filterController.handleDistributionClick(d)
                            // TODO: CAT-2729: When clicking on the bar, we can apply the filter and show the table
                            navigate(-1)
                        }}
                    />
                </Grid>
            </Grid>

            {/*2nd part of the page*/}
            <Grid container sx={{mb: 5}} justifyContent="space-evenly">
                <Grid size={4} container direction="column">
                    <Grid>
                        <Typography className="font-weight-bold key-value text-center" sx={{my: 2}} component="h3">
                            Spend covered by Ai
                        </Typography>
                    </Grid>
                    <Grid>
                        <CoveredByAi
                            data={statisticsDashboardController.spendCoveredByAiBarDataPoint}
                            itemsCoveredByAi={toCurrency(p.currencySymbol, statisticsDashboardController.stats?.covered_by_ai_spend || 0)}
                            percentageCoveredByAi={statisticsDashboardController.coveredByAiSpendPercentage}
                        />
                    </Grid>
                </Grid>


                <Grid size={4} container>
                    <Grid size={12}>
                        <Typography className="font-weight-bold key-value text-center" sx={{my: 2}} component="h3">
                            Suppliers covered by Ai
                            <HelpComponent helpContent={
                                <Typography component="p">
                                    Since a supplier might have some transactions reviewed and some unreviewed,
                                    sum of these might be higher than covered suppliers.
                                </Typography>
                            }/>
                        </Typography>
                    </Grid>
                    <Grid size={12}>
                        <CoveredByAi
                            data={statisticsDashboardController.suppliersCoveredByAiBarDataPoint}
                            itemsCoveredByAi={String(statisticsDashboardController.stats?.covered_suppliers ?? 0)}
                            percentageCoveredByAi={statisticsDashboardController.coveredByAiSuppliersPercentage}
                        />
                    </Grid>
                </Grid>
            </Grid>

            {/*3rd part of the page*/}
            <Grid container sx={{mb: 5}}>
                <Grid size={12}>
                    <Typography className="font-weight-bold key-value">
                        Categorized transactions
                    </Typography>
                    <CategorizedTransactions
                        categorized={statisticsDashboardController.categorizationCategorized}
                        recategorized={statisticsDashboardController.categorizationRecategorized}
                        uncategorized={statisticsDashboardController.categorizationUncategorized}
                    />
                </Grid>

                <Grid size={10}>
                    <Typography className="font-weight-bold key-value">
                        Categories covered by Ai
                    </Typography>
                    <CategoriesCoveredByAi
                        covered={statisticsDashboardController.categoriesCoveredByAiBarDataPoint}
                        uncovered={statisticsDashboardController.categoriesUncoveredByAiBarDataPoint}
                    />
                </Grid>
            </Grid>
        </div>
    );
});
